module.exports = __webpack_public_path__ + "credito-25-d-qe7.png";